<template>
  <div class="relative inline-block">
    <div class="flex space-x-4">
      <button
        disabled
        :class="[
          'inline-flex items-center px-4 py-2 border rounded-md shadow-sm text-sm font-medium transition-colors opacity-50 cursor-not-allowed',
          'border-gray-300 text-gray-500 bg-gray-100'
        ]"
      >
        <i class="material-icons mr-2 text-sm">people</i>
        All User (Disabled)
      </button>
      <button
        disabled
        :class="[
          'inline-flex items-center px-4 py-2 border rounded-md shadow-sm text-sm font-medium transition-colors opacity-50 cursor-not-allowed',
          'border-gray-300 text-gray-500 bg-gray-100'
        ]"
      >
        <i class="material-icons mr-2 text-sm">business</i>
        All Branch (Disabled)
      </button>
      <div class="relative">
        <button
          @click="openDateFilter"
          :class="[
            'inline-flex items-center px-4 py-2 border rounded-md shadow-sm text-sm font-medium transition-colors w-56',
            showDateFilter
              ? 'border-blue-500 bg-blue-50 text-blue-700'
              : 'border-gray-300 text-gray-700 bg-white hover:bg-gray-50'
          ]"
          ref="dateButton"
        >
          <i class="material-icons mr-2 text-sm">date_range</i>
          <span class="truncate">{{ formattedDateRange || "Date" }}</span>
          <span v-if="selectedDateRange" class="ml-auto flex items-center">
            <button
              @click.stop="clearDateFilter"
              class="focus:outline-none ml-2"
              title="Clear date filter"
            >
              <i
                class="material-icons text-gray-400 hover:text-red-500 text-base"
                >close</i
              >
            </button>
          </span>
        </button>
        <transition name="fade">
          <div
            v-if="showDateFilter"
            class="absolute z-10 mt-2 right-0 w-72 bg-white border border-gray-200 rounded-lg shadow-lg p-4"
            @click.stop
          >
            <div class="flex items-center space-x-4">
              <div class="flex-1">
                <label class="block text-xs font-medium text-gray-700 mb-1"
                  >From</label
                >
                <input
                  type="date"
                  v-model="dateRange.from"
                  class="block w-full px-2 py-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-sm"
                />
              </div>
              <div class="flex-1">
                <label class="block text-xs font-medium text-gray-700 mb-1"
                  >To</label
                >
                <input
                  type="date"
                  v-model="dateRange.to"
                  class="block w-full px-2 py-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-sm"
                />
              </div>
            </div>
            <div class="flex justify-end space-x-2 pt-4">
              <button
                @click="applyDateFilter"
                class="px-4 py-1 bg-blue-600 text-white text-xs font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                :disabled="!dateRange.from || !dateRange.to"
              >
                Apply
              </button>
              <button
                @click="clearDateFilter"
                class="px-4 py-1 bg-gray-200 text-gray-700 text-xs font-medium rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
              >
                Clear
              </button>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
function formatDate(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d)) return "";
  return d.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric"
  });
}

export default {
  name: "FilterBar",
  props: {
    filters: {
      type: Object,
      default: () => ({
        user: "all",
        branch: "all"
      })
    }
  },
  data() {
    return {
      showDateFilter: false,
      dateRange: {
        from: "",
        to: ""
      },
      selectedDateRange: ""
    };
  },
  computed: {
    formattedDateRange() {
      if (this.selectedDateRange) {
        const [from, to] = this.selectedDateRange.split(" to ");
        return `${formatDate(from)} – ${formatDate(to)}`;
      }
      return "";
    }
  },
  methods: {
    setFilter(filterType, value) {
      this.$emit("filter-changed", { type: filterType, value });
    },
    openDateFilter() {
      this.showDateFilter = !this.showDateFilter;
      if (this.showDateFilter) {
        document.addEventListener("click", this.handleClickOutside);
      } else {
        document.removeEventListener("click", this.handleClickOutside);
      }
    },
    handleClickOutside(e) {
      if (!this.$refs.dateButton || this.$refs.dateButton.contains(e.target))
        return;
      this.showDateFilter = false;
      document.removeEventListener("click", this.handleClickOutside);
    },
    applyDateFilter() {
      if (this.dateRange.from && this.dateRange.to) {
        this.selectedDateRange = `${this.dateRange.from} to ${this.dateRange.to}`;
        this.$emit("date-filter-applied", { ...this.dateRange });
      }
      this.showDateFilter = false;
      document.removeEventListener("click", this.handleClickOutside);
    },
    clearDateFilter() {
      this.dateRange = { from: "", to: "" };
      this.selectedDateRange = "";
      this.showDateFilter = false;
      this.$emit("date-filter-cleared");
      document.removeEventListener("click", this.handleClickOutside);
    }
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
